<template>
  <div class="audio-play-component">
    <div
      class="audio-play fixed bottom-0 left-0 text-center h-10 leading-10 w-screen flex justify-evenly items-center z-50"
      style="background-color: #ccc"
      v-if="audio"
    >
      <div class="flex-shrink-0">当前音频：</div>
      <audio
        class="audios-play"
        ref="audio"
        @pause="onPause"
        @play="onPlay"
        @canplay="getDuration"
        controlsList="nodownload"
        controls="controls"
        :src="audio.imgArr"
        style="width: 80%; height: 40px"
        v-playback-rate="audio.rate"
      ></audio>
      <div class="flex-shrink-0 flex">
        <span class="ml-1">播放速度：</span>
        <el-slider v-model="audio.rate" :min="0.5" :max="4" :step="0.1" style="width: 100px"></el-slider>
        <!-- <el-select v-model="audio.rate" placeholder="请选择播放速率" size="mini">
          <el-option
            v-for="item in rateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
      </div>
      <div class="flex-shrink-0">
        <i class="el-icon-close cursor-pointer text-white" @click="close"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  directives: {
    playbackRate(el, binding) {
      el.playbackRate = binding.value
    }
  },
  props: {
    audio: {
      type: Object,
      default: () => {
        return {}
      }
    },
    duringCallContent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // 倍速选项
      rateOptions: [
        {
          value: 0.5,
          label: '0.5倍速'
        },
        {
          value: 1.0,
          label: '1.0倍速'
        },
        {
          value: 1.5,
          label: '1.5倍速'
        },
        {
          value: 2.0,
          label: '2.0倍速'
        },
        {
          value: 4.0,
          label: '4.0倍速'
        },
        {
          value: 8.0,
          label: '8.0倍速'
        }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('closeAudioPlay')
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false
    },
    // 音频canplay
    getDuration() {
      let audioArr = document.getElementsByClassName('audios-play')
      let time = 0
      audioArr.forEach(element => {
        time += element.duration
      })
      this.audioTime = parseInt(time)
      let amountIssue = 0
      this.duringCallContent.answerContent.forEach(item => {
        item.questionType != 20 ? (amountIssue += 1) : ''
      })
      // this.amountIssue = amountIssue;
      // this.isAlert = true;
    }
  }
}
</script>
